<template>
    <ul class="pagination pagination-sm no-margin pull-right">
        <li class="paginate_button previous">
            <button :disabled="pagination.current_page === 1" class="paginate_button previous" @click.prevent="pagination.current_page-- && $emit('newTotal')">{{'previous' | translate | capitalize}}</button>
        </li>
        <template v-for="n in chunk">
            <li class="paginate_button">
                <button :class="[pagination.current_page === n ? 'active' : '', 'paginate_button', 'page-link']" @click.prevent="log(n)">{{n === 'x' || n === 'y' || n === 'z' ? '...' : n}}</button>
            </li>
        </template>
        <li :disabled="pagination.total_pages === pagination.current_page">
            <button class="paginate_button next" :disabled="pagination.total_pages === pagination.current_page" @click.prevent="pagination.current_page++ && $emit('newTotal')">{{'next' | translate | capitalize}}</button>
        </li>
    </ul>
</template>
<script>
	export default {
		props: ['total', 'perPage', 'pagination', 'currentPage'],
		data () {
			return {
				chunk: []
			}
		},
		methods: {
			updateChunk () {
				if (this.pagination.total_pages >= 10) {
					if (this.pagination.current_page < 4) {
						this.chunk = [1, 2, 3, 4, 'z', this.pagination.total_pages]
					} else if (this.pagination.current_page > this.pagination.total_pages - 3) {
						this.chunk = [1, 'x', this.pagination.total_pages - 2, this.pagination.total_pages - 1, this.pagination.total_pages]
					} else {
						this.chunk = [1, 'x', this.pagination.current_page - 1, this.pagination.current_page, this.pagination.current_page + 1, 'y', this.pagination.total_pages]
					}
				} else {
					this.chunk = this.pagination.total_pages
				}
			},
			log (n) {
				if (n === 'x') {
					this.pagination.current_page -= 3
				} else if (n === 'y') {
					this.pagination.current_page += 3
				} else if (n === 'z') {
					this.pagination.current_page++
				} else {
					this.pagination.current_page = n
				}
				this.$emit('newTotal', n)
			}
		},
		computed: {
			numberOfPages () {
				const result = Math.ceil(this.total / this.perPage)
				return (result < 1) ? 1 : result
			}
		},
		mounted () {
			this.updateChunk()
		},
		watch: {
			pagination () {
				this.updateChunk()
			},
      currentPage () {
				this.updateChunk()
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/tools/ChartPaginationComponent.vue